import { type PropsWithChildren } from "react";
import Footer from "@/layouts/footer/Footer";
import Header from "@/layouts/header/Header";
import IdentityGuard from "@/components/identityGuard/IdentityGuard";
import { StyledContainer, StyledMain } from "./GenerationPageLayout.styles";

const GenerationPageLayout = ({ children }: PropsWithChildren) => (
  <StyledContainer>
    <IdentityGuard />
    <Header variant="primary" showUserInfo={true} />
    <StyledMain>{children}</StyledMain>
    <Footer />
  </StyledContainer>
);

export default GenerationPageLayout;
